import { useCallback } from "react";
import type { Task } from "@common/types/task";
import { useViewOnlyRefusal } from "@hooks/permissions/useViewOnlyRefusal";
import { useOverlays } from "contexts/OverlayContext";

/**
 * Duplicate task: opens the create form filled from a task, in the scope
 * this is called from (the task's own workspace on the organization page).
 */
export const useDuplicateTask = () => {
    const { openOverlay } = useOverlays();
    const { refuseIfViewOnly } = useViewOnlyRefusal();

    return useCallback(
        (task: Task) => {
            // Opens a create form the server can only refuse on save
            // (PRO-11345).
            if (refuseIfViewOnly()) {
                return;
            }
            openOverlay("createTask", {
                type: task.type,
                initialValues: {
                    title: task.title,
                    description: task.description,
                    assigneeId: task.assigneeId,
                    priority: task.priority ?? undefined,
                    dueDate: task.dueDate,
                    entityIds: task.entityIds ?? undefined,
                    groupId: task.groupId,
                    estimatedTime: task.estimatedTime,
                    closeId: task.closeId,
                    closeStageId: task.closeStageId,
                },
            });
        },
        [openOverlay, refuseIfViewOnly],
    );
};
